import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@rd/core/auth/guards/auth.guard';
import { PageNotFoundComponent } from '@rd/core/views/page-not-found/page-not-found.component';
import { WestpacAuthGuard } from '@rd/wl/westpac/auth.guard';
import { WestpacHomePageComponent } from '@rd/wl/westpac/components/home-page/home-page.component';

const routes: Routes = [
  {
    path: '',
    component: WestpacHomePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'gift_card',
    loadChildren: () =>
      import('@rd/wl/westpac/gift-card/gift-card-wrapper.module').then(
        (m) => m.WestpacGiftCardWrapperModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'offers',
    loadChildren: () =>
      import('./offer/offer-wrapper.module').then((m) => m.OfferWrapperModule),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: AuthGuard,
      useClass: WestpacAuthGuard,
    },
  ],
})
export class AppRoutingModule {}
